export enum AppointmentActionEnum {
  New = 'new',
  Manage = 'manage',
  Pay = 'pay',
  ChangeClinician = 'change-clinician',
  CancelNoRefund = 'cancel-no-refund',
  ReviewIntake = 'review-intake',
  ManageSchedule = 'manage-schedule',
}
